Ext.define('SA.data.LocationAliases', {
    extend: 'Ext.util.Observable',

    singleton: true,

    resource: 'user/locationAliases',

    get(locationSeries) {
        return this.all[locationSeries];
    },

    getListener(callback) {
        return SA.ListenerFactory.create(this, 'change', (locationSeries, alias) => callback({locationSeries, alias}));
    },

    async loadAll() {
        this.all = await SA.Ajax.request({resource: this.resource});
    },

    async set(locationSeries, alias) {
        if (alias) {
            this.all[locationSeries] = alias;
        } else {
            Reflect.deleteProperty(this.all, locationSeries);
        }

        await SA.Ajax.request({
            data: this.all,
            method: 'set',
            resource: this.resource
        });

        this.fireEvent('change', locationSeries, alias);
    }
});